// Rehberin ve sayfa panellerinin ortak özellik envanteri.
export interface HelpFeature { title: string; description: string; steps: string }
export interface HelpGuide { id: string; title: string; route: string; destination: string; summary: string; features: HelpFeature[]; tip: string; category: string }
export const helpGuides: HelpGuide[] = [
  {
    "id": "general",
    "title": "Genel özellikler",
    "route": "",
    "destination": "/dashboard",
    "summary": "Uygulama genelindeki araçları ve gezinme seçeneklerini tanıyın.",
    "features": [
      {
        "title": "Menü ve mobil gezinme",
        "description": "Sayfalar arasında geçiş yapın, masaüstünde menüyü açık tutun.",
        "steps": "Sol menüyü kullanın; sabitleme düğmesiyle menüyü açık tutun. Küçük ekranlarda üstteki menü düğmesini açın."
      },
      {
        "title": "Genel arama",
        "description": "Kayıtlara hızlıca ulaşın.",
        "steps": "Geniş ekranda üst çubuktaki aramayı açın ve aradığınız kaydı yazın."
      },
      {
        "title": "AI arama",
        "description": "Yapay zekâ destekli arama alanını kullanın.",
        "steps": "Geniş ekranda üst çubuktaki AI alanını açın."
      },
      {
        "title": "Alarm bildirimleri",
        "description": "Yeni aktif alarmları ve önem dağılımını görün.",
        "steps": "Üst çubuktaki zil simgesini açın; ayrıntılar için Alarmlar Sayfasına Git düğmesini kullanın."
      },
      {
        "title": "Tablo araçları",
        "description": "Destekleyen tablolarda sıralama ve filtreleme ile kayıtları daraltın.",
        "steps": "Sütun başlıklarını ve sayfanın filtrelerini kullanın. Araçlar tabloya göre değişir."
      }
    ],
    "tip": "",
    "category": "Genel"
  },
  {
    "id": "home",
    "title": "Ana sayfa",
    "route": "/dashboard",
    "destination": "/dashboard",
    "summary": "Portföyün üretim ve cihaz durumunu tek ekranda izleyin.",
    "features": [
      {
        "title": "Metrikler ve durum kartları",
        "description": "Üretim ve cihaz durumunun özetini görün.",
        "steps": "Metrikler bölümünü açın; üstteki etiket filtresiyle kapsamı daraltın."
      },
      {
        "title": "Üretim grafiği",
        "description": "Portföyün üretim eğilimini inceleyin.",
        "steps": "Üretim grafiğinde dönemleri karşılaştırın."
      },
      {
        "title": "İnverter ısı haritası",
        "description": "Düşük performanslı cihazları fark edin.",
        "steps": "Haritadaki invertere tıklayarak detayına geçin."
      }
    ],
    "tip": "Etiket seçimi kaydedilir; sonraki ziyaretinizde aynı kapsamla devam edebilirsiniz.",
    "category": "İzleme"
  },
  {
    "id": "plants",
    "title": "Santraller",
    "route": "/dashboard/powerplants",
    "destination": "/dashboard/powerplants",
    "summary": "Santral portföyünü bulun ve detaylara geçin.",
    "features": [
      {
        "title": "Santral listesi ve filtreler",
        "description": "Santralleri arayın, durum ve etiketlerine göre daraltın.",
        "steps": "Listenin üstündeki arama ve filtreleri kullanın."
      },
      {
        "title": "Santral detayına geçiş",
        "description": "Üretim, cihaz ve analiz ekranlarına ulaşın.",
        "steps": "İlgili santral kaydını açın."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "plant",
    "title": "Santral detayı",
    "route": "/dashboard/powerplants/:uuid_id",
    "destination": "/dashboard/powerplants",
    "summary": "Seçili santralin üretimini, cihazlarını ve performansını inceleyin.",
    "features": [
      {
        "title": "Üretim ve performans",
        "description": "Özet kartları, üretim, inverter ve performans grafiklerini inceleyin.",
        "steps": "Üretim sekmesini açıp grafiklerin tarih ve dönem seçeneklerini kullanın."
      },
      {
        "title": "Enerji akışı",
        "description": "Enerjinin sistem içindeki akışını görün.",
        "steps": "Akış sekmesini açın."
      },
      {
        "title": "Panel, SmartLogger, sayaç ve sensörler",
        "description": "Santrale bağlı donanım bilgilerini inceleyin.",
        "steps": "İlgili sekmeyi seçin; donanım tanımı olmayan sekmeler kullanılamaz."
      },
      {
        "title": "Santral ayarları ve iletişim",
        "description": "Santral bilgilerini ve iletişim kartlarını yönetin.",
        "steps": "İşlemler menüsünden Düzenle veya İletişim Kartı seçeneğini açın."
      },
      {
        "title": "Canlı Modbus",
        "description": "Cihazların canlı Modbus verilerini inceleyin.",
        "steps": "İşlemler menüsünden Canlı Modbus Verileri seçeneğini açın."
      },
      {
        "title": "Analizler ve tahminler",
        "description": "Sağlık, PVGIS ve üretim tahmini araçlarına ulaşın.",
        "steps": "İşlemler menüsünden ilgili analizi veya tahmini seçin."
      },
      {
        "title": "Santral raporları",
        "description": "Günlük, aylık, özel aylık ve bütçe karşılaştırma raporlarına ulaşın.",
        "steps": "İşlemler menüsündeki Raporlar alt menüsünü açın."
      },
      {
        "title": "Etiket düzenleme",
        "description": "Santrali etiketlerle sınıflandırın.",
        "steps": "İşlemler menüsünden etiket düzenlemeyi açın."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "health",
    "title": "Santral sağlık analizi",
    "route": "/dashboard/powerplants/:uuid_id/health-analysis",
    "destination": "/dashboard/powerplants",
    "summary": "Santralin sağlık analizini ve raporunu inceleyin.",
    "features": [
      {
        "title": "Sağlık analizi",
        "description": "Üretim ve cihaz durumuna ilişkin analiz sonuçlarını değerlendirin.",
        "steps": "Santral detayındaki Santral Sağlığı ve Raporu işlemini açın ve analiz seçeneklerini kullanın."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "pvgis",
    "title": "PVGIS analizi",
    "route": "/dashboard/powerplants/:uuid_id/pvgis-analysis",
    "destination": "/dashboard/powerplants",
    "summary": "Beklenen üretimi ve kayıpları PVGIS verileriyle değerlendirin.",
    "features": [
      {
        "title": "Aylık üretim ve karşılaştırma",
        "description": "Aylık üretim beklentisini ve gerçekleşen üretimi karşılaştırın.",
        "steps": "Santral işlemlerinden PVGIS Analizi seçeneğini açın; aylık grafiklere bakın."
      },
      {
        "title": "Kayıp analizi",
        "description": "Üretimi etkileyen kayıp bileşenlerini görün.",
        "steps": "Analiz ekranındaki kayıp analizi bölümünü inceleyin."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "forecast",
    "title": "Forecast.Solar tahmini",
    "route": "/dashboard/powerplants/:uuid_id/forecast-solar-analysis",
    "destination": "/dashboard/powerplants",
    "summary": "Saatlik güç ve günlük enerji beklentisini görün.",
    "features": [
      {
        "title": "Saatlik ve günlük tahmin",
        "description": "Gelecek üretim beklentisini değerlendirin.",
        "steps": "Santral işlemlerinden Forecast.Solar Tahmini seçeneğini açın; saatlik ve günlük grafikleri inceleyin."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "flow",
    "title": "Enerji akışı",
    "route": "/dashboard/powerplants/:uuid_id/flow",
    "destination": "/dashboard/powerplants",
    "summary": "Santralin enerji akış görünümünü inceleyin.",
    "features": [
      {
        "title": "Akış görünümü",
        "description": "Enerji bileşenleri arasındaki ilişkiyi izleyin.",
        "steps": "Santral detayındaki Akış sekmesini açın."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "sites",
    "title": "Sahalar",
    "route": "/dashboard/sites",
    "destination": "/dashboard/sites",
    "summary": "Sahaları ve bağlı ölçüm sistemlerini bulun.",
    "features": [
      {
        "title": "Saha listesi",
        "description": "Aktif ve pasif sahaları, bağlı santral etiketleriyle filtreleyin.",
        "steps": "Arama, durum ve etiket filtrelerini kullanın."
      },
      {
        "title": "Bağlı sistem göstergeleri",
        "description": "OSOS, EKK ve Power Meter tanımlarını görün.",
        "steps": "Saha satırındaki sistem simgelerini inceleyip saha detayını açın."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "site",
    "title": "Saha detayı",
    "route": "/dashboard/sites/:uuid_id",
    "destination": "/dashboard/sites",
    "summary": "OSOS, EKK ve sayaç verilerini saha düzeyinde takip edin.",
    "features": [
      {
        "title": "OSOS enerji verileri",
        "description": "Endeks, fatura ve yük profili verilerini inceleyin.",
        "steps": "OSOS sekmesinde tarih ve zaman serisi seçeneklerini kullanın; desteklenen hücrelerle ayrıntıya inin."
      },
      {
        "title": "EKK ve Power Meter",
        "description": "Elektriksel ölçümleri inceleyin.",
        "steps": "Tanımı bulunan aktif sahalarda EKK veya Power Meter sekmesini seçin."
      },
      {
        "title": "GridBox veri takvimi",
        "description": "Verilerin gün bazında kapsamasını görün.",
        "steps": "İşlemler menüsünden GridBox Veri Takvimi seçeneğini açın."
      },
      {
        "title": "GridBox yenileme ve bağlantı testi",
        "description": "Verileri yenileyin ve bağlantının durumunu kontrol edin.",
        "steps": "Veri yenileme düğmesini veya Düzenle > Bağlantı bölümündeki bağlantı testini kullanın."
      },
      {
        "title": "Saha yapılandırması",
        "description": "Genel bilgiler, bağlantılar, santraller ve EKK tanımlarını yönetin.",
        "steps": "İşlemler > Düzenle menüsündeki ilgili sekmeyi açın."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "inverters",
    "title": "İnverterler",
    "route": "/dashboard/inverters",
    "destination": "/dashboard/inverters",
    "summary": "İnverterleri portföy veya santral kapsamında inceleyin.",
    "features": [
      {
        "title": "İnverter listesi",
        "description": "Cihaz durumlarını ve üretim değerlerini karşılaştırın.",
        "steps": "Liste filtrelerini kullanın ve incelemek istediğiniz inverteri açın."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "plant-inverters",
    "title": "Santralin inverterleri",
    "route": "/dashboard/powerplants/:uuid_id/inverters",
    "destination": "/dashboard/powerplants",
    "summary": "Tek santrale ait inverterleri inceleyin.",
    "features": [
      {
        "title": "Santral kapsamı",
        "description": "İnverter listesini seçili santralle sınırlandırın.",
        "steps": "Santralden inverter listesine geçin ve cihaz detayını açın."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "inverter",
    "title": "İnverter detayı",
    "route": "/dashboard/inverters/:id",
    "destination": "/dashboard/inverters",
    "summary": "İnverter üretimini ve bağlı stringleri inceleyin.",
    "features": [
      {
        "title": "Güç ve üretim geçmişi",
        "description": "Saatlik, günlük, aylık ve yıllık değerleri inceleyin.",
        "steps": "Üretim grafiğindeki dönem seçeneklerini kullanın."
      },
      {
        "title": "Stringler ve panel bilgisi",
        "description": "String ölçümlerini ve panel özetini görün.",
        "steps": "Cihaz kartından ilgili stringe geçin; tanımlıysa panel özetini inceleyin."
      },
      {
        "title": "String panel yapılandırması",
        "description": "Stringlere atanmış panel bilgilerini düzenleyin.",
        "steps": "İnverter işlemleri menüsünden String Panel Yapılandırması seçeneğini açın."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "string",
    "title": "String detayı",
    "route": "/dashboard/inverters/:id/string/:stringNumber",
    "destination": "/dashboard/inverters",
    "summary": "Stringin akım, gerilim, güç ve panel bilgilerini inceleyin.",
    "features": [
      {
        "title": "String ölçümleri",
        "description": "Akım, gerilim ve güç verilerini değerlendirin.",
        "steps": "İnverter detayından stringi açın ve ölçüm grafiklerini inceleyin."
      },
      {
        "title": "Panel bilgisini düzenleme",
        "description": "Seçili stringin panel atamasını güncelleyin.",
        "steps": "String işlemleri menüsünden String Panel Bilgisini Düzenle seçeneğini açın."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "sensors",
    "title": "Sensörler",
    "route": "/dashboard/sensors",
    "destination": "/dashboard/sensors",
    "summary": "Sensör kayıtlarını bulun ve ölçüm detaylarını açın.",
    "features": [
      {
        "title": "Sensör listesi",
        "description": "Sensörleri arayın ve bağlı santral etiketleriyle daraltın.",
        "steps": "Liste filtrelerini kullanıp ilgili sensörü açın."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "sensor",
    "title": "Sensör detayı",
    "route": "/dashboard/sensors/:uuid_id",
    "destination": "/dashboard/sensors",
    "summary": "Sensör verilerini ve kullanıldığı santralleri inceleyin.",
    "features": [
      {
        "title": "Ölçümler ve santral bağlantıları",
        "description": "Sensörün ölçüm geçmişini ve kullanım yerlerini görün.",
        "steps": "Sensör detayındaki grafik ve Kullanıldığı Santraller bölümünü inceleyin."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "alarms",
    "title": "Alarmlar",
    "route": "/dashboard/alarms",
    "destination": "/dashboard/alarms",
    "summary": "Aktif alarmları inceleyin ve gerekli takibi başlatın.",
    "features": [
      {
        "title": "Önem ve kayıt filtreleri",
        "description": "Majör, minör ve uyarı kayıtlarını ayırın.",
        "steps": "Önem filtresi ve tablo filtreleriyle ilgili kayıtları bulun."
      },
      {
        "title": "Alarm detayı",
        "description": "Alarmın santral ve cihaz bilgilerini inceleyin.",
        "steps": "İlgili alarm kaydının detayını açın."
      },
      {
        "title": "Alarmdan görev oluşturma",
        "description": "İncelenecek alarmı takip edilebilir işe dönüştürün.",
        "steps": "Alarm satırındaki Görev Oluştur işlemini kullanın."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "alarm",
    "title": "Alarm detayı",
    "route": "/dashboard/alarms/detail",
    "destination": "/dashboard/alarms",
    "summary": "Seçili alarmın teknik ve zaman bilgilerini görün.",
    "features": [
      {
        "title": "Alarm bilgileri",
        "description": "Önem, cihaz ve santral bilgilerini inceleyin.",
        "steps": "Alarmlar listesinden bir kaydın detayına geçin."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "investors",
    "title": "Yatırımcılar",
    "route": "/dashboard/investor",
    "destination": "/dashboard/investor",
    "summary": "Yatırımcı kayıtlarını ve bağlı santralleri yönetin.",
    "features": [
      {
        "title": "Yatırımcı listesi ve yeni kayıt",
        "description": "Yatırımcıları bulun veya yeni yatırımcı tanımlayın.",
        "steps": "Liste araması ve etiket filtresini kullanın; yeni kayıt düğmesiyle yatırımcı ekleyin."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "investor",
    "title": "Yatırımcı detayı",
    "route": "/dashboard/investor/:uuid_id",
    "destination": "/dashboard/investor",
    "summary": "Yatırımcı bilgileri, santraller ve raporlara ulaşın.",
    "features": [
      {
        "title": "Yatırımcı bilgileri ve santraller",
        "description": "İletişim bilgilerini düzenleyin, bağlı santralleri görün.",
        "steps": "İşlemlerden düzenlemeyi açın; santral listesinden detaya geçin."
      },
      {
        "title": "Yatırımcı raporları",
        "description": "Günlük, aylık ve bütçe karşılaştırma raporlarını açın.",
        "steps": "İşlemler > Raporlar menüsünü kullanın."
      },
      {
        "title": "Kayıt silme",
        "description": "Uygun yatırımcı kaydını kaldırın.",
        "steps": "Sil işlemini kullanın; bağlı santrali olan yatırımcı silinemez."
      }
    ],
    "tip": "",
    "category": "İzleme"
  },
  {
    "id": "maintenance",
    "title": "Bakım sözleşmeleri",
    "route": "/dashboard/maintenance",
    "destination": "/dashboard/maintenance",
    "summary": "Bakım teklif ve sözleşmelerini, süre ve ücretlerini yönetin.",
    "features": [
      {
        "title": "Sözleşme portföyü",
        "description": "Taslak, teklif, aktif ve süresi yaklaşan sözleşmeleri görün.",
        "steps": "Özet kartlarını ve liste filtrelerini kullanın."
      },
      {
        "title": "Sözleşme oluşturma ve düzenleme",
        "description": "Yatırımcı, süre, iletişim ve santral bazlı ücretleri kaydedin.",
        "steps": "Yeni sözleşme veya kayıt düzenleme işlemini açın."
      },
      {
        "title": "Sözleşme belgeleri",
        "description": "Sözleşme belgelerine ulaşın.",
        "steps": "Kayıt işlemlerinden sunulan belge ve PDF seçeneklerini kullanın."
      }
    ],
    "tip": "",
    "category": "Operasyon"
  },
  {
    "id": "tasks",
    "title": "Görevler",
    "route": "/dashboard/tasks",
    "destination": "/dashboard/tasks",
    "summary": "Operasyon işlerini liste ve Kanban üzerinden takip edin.",
    "features": [
      {
        "title": "Kanban ve klasik görünüm",
        "description": "Görevleri durumlarına göre veya tabloda inceleyin.",
        "steps": "Üstteki Kanban ve klasik görünüm seçenekleri arasında geçiş yapın."
      },
      {
        "title": "Görev oluşturma ve detay",
        "description": "Yeni iş kaydı açın ve görevin ayrıntılarını takip edin.",
        "steps": "Yeni düğmesini kullanın veya mevcut görevi açın."
      },
      {
        "title": "Yorumlar ve ekler",
        "description": "Görevle ilgili yazışma ve görselleri bir arada tutun.",
        "steps": "Görev detayındaki yorum ve dosya alanlarını kullanın."
      }
    ],
    "tip": "",
    "category": "Operasyon"
  },
  {
    "id": "agile",
    "title": "Agile panosu",
    "route": "/dashboard/agile",
    "destination": "/dashboard/agile",
    "summary": "İşleri pano üzerinden organize edin.",
    "features": [
      {
        "title": "Pano ve görev kartları",
        "description": "Görevleri durumları ve tarihleriyle izleyin.",
        "steps": "Pano filtrelerini kullanın ve görev kartını açın."
      },
      {
        "title": "Görev iletişimi",
        "description": "Görev ayrıntılarını ve yorumlarını takip edin.",
        "steps": "Kart detayında yorum alanını kullanın."
      }
    ],
    "tip": "",
    "category": "Operasyon"
  },
  {
    "id": "reports",
    "title": "Raporlar",
    "route": "/dashboard/reports",
    "destination": "/dashboard/reports",
    "summary": "Yönetim ve yatırımcı raporlarını hazırlayın.",
    "features": [
      {
        "title": "Rapor oluşturma ve PDF",
        "description": "Santral ve yatırımcı raporlarını seçilen dönem için açın.",
        "steps": "Rapor kartını seçin; gerekli santral, yatırımcı ve tarih bilgilerini girin."
      },
      {
        "title": "Tarih aralıkları",
        "description": "Bu ay, bu yıl, geçen ay veya özel dönem seçin.",
        "steps": "Raporun tarih seçicisinden uygun dönemi belirleyin."
      },
      {
        "title": "Otomatik rapor zamanlama",
        "description": "Düzenli rapor üretimini yapılandırın.",
        "steps": "Rapor işlemlerinden Otomatik Zamanla seçeneğini açın."
      },
      {
        "title": "Rapor ayarları",
        "description": "Destekleyen raporların görünümünü düzenleyin.",
        "steps": "Rapor Ayarları bölümünden renk ve yerleşim seçeneklerini kaydedin."
      }
    ],
    "tip": "",
    "category": "Operasyon"
  },
  {
    "id": "automation",
    "title": "Otomasyon",
    "route": "/dashboard/automation",
    "destination": "/dashboard/automation",
    "summary": "Bağlı iş akışlarını ve çalışma kayıtlarını izleyin.",
    "features": [
      {
        "title": "İş akışları",
        "description": "Bağlı otomasyonların durumlarını görün ve düzenleyin.",
        "steps": "Workflows listesindeki ilgili akışın düzenleme işlemini açın."
      },
      {
        "title": "Elle çalıştırma ve geçmiş",
        "description": "Akışı tetikleyin, etkinlik kayıtlarını inceleyin.",
        "steps": "Webhook içeren akışlarda elle çalıştırmayı kullanın; Activity Log bölümüne bakın."
      }
    ],
    "tip": "İş akışları bağlı otomasyon hizmetine ihtiyaç duyar.",
    "category": "Sistem"
  },
  {
    "id": "management",
    "title": "Yönetim",
    "route": "/dashboard/management",
    "destination": "/dashboard/management",
    "summary": "Kullanıcıları, katalogları ve uygulama ayarlarını yönetin.",
    "features": [
      {
        "title": "Kullanıcılar ve yatırımcı kullanıcıları",
        "description": "Hesap kayıtlarını yönetin.",
        "steps": "İlgili kullanıcı sekmesini açın ve kayıt işlemlerini kullanın."
      },
      {
        "title": "Panel modelleri",
        "description": "Panel kataloğunu ve değişiklik geçmişini yönetin.",
        "steps": "Panel Modelleri sekmesinde kayıt ekleyin, düzenleyin veya geçmişini açın; kullanılan model silinemez."
      },
      {
        "title": "EKK tanımları",
        "description": "EKK cihaz türlerini yapılandırın.",
        "steps": "EKK Tanımları sekmesini açın."
      },
      {
        "title": "Etiketler",
        "description": "Kayıtları sınıflandıran etiketleri yönetin.",
        "steps": "Etiketler sekmesinde ilgili kategoriyi seçin."
      },
      {
        "title": "AI ayarları",
        "description": "Model, sağlayıcı, bağlam ve genel talimatları yapılandırın.",
        "steps": "Ayarlar sekmesinde AI seçeneklerini düzenleyin."
      },
      {
        "title": "Uygulama parametreleri",
        "description": "Uygulamanın yapılandırma değerlerini yönetin.",
        "steps": "Parametreler sekmesinde ilgili değeri düzenleyin."
      }
    ],
    "tip": "",
    "category": "Sistem"
  },
  {
    "id": "monitoring",
    "title": "Sistem izleme",
    "route": "/dashboard/monitoring",
    "destination": "/dashboard/monitoring",
    "summary": "Servis, veri tabanı ve altyapı durumunu inceleyin.",
    "features": [
      {
        "title": "Servisler ve loglar",
        "description": "Servis durumlarını ve günlükleri inceleyin.",
        "steps": "Servisler sekmesinden ilgili servisi seçin."
      },
      {
        "title": "Database ve Sunucu",
        "description": "Veri tabanı performansını ve sunucu kaynaklarını görün.",
        "steps": "Database veya Sunucu sekmesini açın."
      },
      {
        "title": "AI Master ve Oturumlar",
        "description": "AI çalışmalarını ve kullanıcı oturumlarını inceleyin.",
        "steps": "İlgili sekmeyi seçin."
      },
      {
        "title": "Message Queue ve Redis",
        "description": "Kuyruk ve önbellek durumunu izleyin.",
        "steps": "Message Queue veya Redis sekmesini açın."
      },
      {
        "title": "Sorgular ve tablolar",
        "description": "Sorgu ayrıntıları, tablo verileri ve şemaları inceleyin.",
        "steps": "Sorgular veya Tablolar sekmesinde bir kaydı açın."
      },
      {
        "title": "GridBox Backfill",
        "description": "Geçmiş veri tamamlama işlemlerini inceleyin.",
        "steps": "GridBox Backfill sekmesini açın."
      },
      {
        "title": "SQL Workbench",
        "description": "Veri tabanı çalışma alanına ulaşın.",
        "steps": "SQL Workbench sekmesini açın; işlemlerin veri üzerindeki etkisini değerlendirin."
      }
    ],
    "tip": "",
    "category": "Sistem"
  },
  {
    "id": "studio",
    "title": "Bakım Studio (örnek tasarım)",
    "route": "/dashboard/maintenance-studio",
    "destination": "/dashboard/maintenance-studio",
    "summary": "Bakım arayüzünün örnek tasarımını inceleyin.",
    "features": [
      {
        "title": "Örnek portföy ve kartlar",
        "description": "Bakım ekranı tasarım seçeneklerini görün.",
        "steps": "Studio sayfasındaki örnek kart ve tablo görünümlerini inceleyin."
      }
    ],
    "tip": "Bu ekran örnek verili tasarım çalışmasıdır; gerçek sözleşmeler için Bakım sayfasını kullanın.",
    "category": "Sistem"
  },
  {
    "id": "ui",
    "title": "UI bileşenleri (örnekler)",
    "route": "/dashboard/ui",
    "destination": "/dashboard/ui",
    "summary": "Arayüz bileşenlerinin örneklerini inceleyin.",
    "features": [
      {
        "title": "Bileşen kataloğu",
        "description": "Buton, tablo, form, panel, grafik ve bildirim örneklerini görün.",
        "steps": "İlgili bileşen bölümünü açın."
      }
    ],
    "tip": "Bu sayfa bileşen gösterimidir; örnek işlemler gerçek iş kayıtları değildir.",
    "category": "Sistem"
  }
];
export function normalizeSearch(value: string) {
  return value.toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i');
}
export function matchesGuide(guide: HelpGuide, query: string) {
  const text = normalizeSearch([guide.title, guide.summary, guide.tip, ...guide.features.flatMap(f => [f.title, f.description, f.steps])].join(' '));
  return normalizeSearch(query).split(/\s+/).filter(Boolean).every(word => text.includes(word));
}
export function guideForPath(path: string) {
  const canonical = path.replace(/\/$/, '').replace(/^(\/dashboard\/investor\/[^/]+)\/detail$/, '$1').replace(/^\/dashboard\/management\/users$/, '/dashboard/management');
  return helpGuides.find(guide => guide.route && new RegExp('^' + guide.route.replace(/:[^/]+/g, '[^/]+') + '$').test(canonical));
}
